import { DateField } from '@mews-commander/form';
import { DateTimeUtils, useAppNowUtc, useTimezone } from '@mews/framework';
import { StructuredDate } from '@optimus-web/core';

interface LedgersDateFieldProps {
    name: string;
    label?: React.ReactNode;
    handleDateChange?: (date: StructuredDate) => void;
    maxDate?: StructuredDate;
    minDate?: StructuredDate;
}
export const LedgersDateField = ({ name, label, handleDateChange, maxDate, minDate }: LedgersDateFieldProps) => {
    const now = useAppNowUtc();
    const timezone = useTimezone();
    return (
        <DateField
            data-test-id="ledgers-date"
            name={name}
            mode="iso"
            label={label || undefined}
            maxDate={maxDate || DateTimeUtils.utcToStructuredDate(now.value, timezone)}
            minDate={minDate}
            onDateChange={handleDateChange}
        />
    );
};
